import clinic from './clinic';
import form from './form';
import generate from './generate';
import filter from './filter';

export default {
  clinic,
  form,
  generate,
  filter,
};
